<template>
  <div class="linkListFilterPanel">
    <div class="commandDeck">
      <div class="commandDeck__zone commandDeck__zone--filters">
        <div class="filterDeckHeader">
          <div class="filterDeckHeader__leading">
            <span class="zoneHeader__title">筛选条件</span>
            <div v-if="activeFilterCount" class="filterChips">
              <span class="filterChip">已筛选 {{ activeFilterCount }} 项</span>
              <button
                type="button"
                class="filterChip filterChip--clear"
                @click="$emit('reset-and-search')"
              >
                清除
              </button>
            </div>
          </div>
          <div class="actionBar">
            <el-button
              class="actionButton actionButtonQuery"
              type="primary"
              size="small"
              icon="el-icon-search"
              @click="$emit('search')"
            >
              查询
            </el-button>
            <el-button
              class="actionButton actionButtonOutline"
              size="small"
              icon="el-icon-plus"
              v-check-role
              @click="$emit('go-create')"
            >
              新增样式
            </el-button>
            <el-button
              class="actionButton actionButtonGhost actionButton--reset"
              size="small"
              icon="el-icon-refresh-left"
              @click="$emit('reset-filters')"
            >
              重置
            </el-button>
          </div>
        </div>
        <div class="filterGrid filterGrid--three">
          <div class="filterItem">
            <span class="searchText">样式名称</span>
            <el-input
              class="filterControl"
              placeholder="请输入样式名称"
              prefix-icon="el-icon-search"
              :value="styleName"
              size="small"
              clearable
              @input="$emit('update:styleName', $event)"
              @keydown.enter.native="$emit('search')"
            />
          </div>
          <div class="filterItem">
            <span class="searchText">样式类型</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="styleType"
              placeholder="请选择样式类型"
              size="small"
              clearable
              filterable
              @change="$emit('update:styleType', $event)"
            >
              <el-option
                v-for="item in styleTypeOptions"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
          </div>
          <div class="filterItem">
            <span class="searchText">展示方式</span>
            <el-select
              class="filterControl"
              popper-class="linkListFilterDropdown"
              :value="displayMode"
              placeholder="请选择展示方式"
              size="small"
              clearable
              @change="$emit('update:displayMode', $event)"
            >
              <el-option
                v-for="item in displayModeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </div>
        </div>
      </div>
    </div>
    <div v-if="showPanelSummary" class="filterPanelSummary">
      <span class="filterPanelSummary__label">共</span>
      <strong class="filterPanelSummary__count">{{ panelTotalCount }}</strong>
      <span class="filterPanelSummary__label">条</span>
    </div>
  </div>
</template>

<script>
import { DISPLAY_MODE_OPTIONS } from './styleListHelpers'

export default {
  name: 'StyleListFilterPanel',
  props: {
    styleName: { type: String, default: '' },
    styleType: { type: [String, Number], default: '' },
    displayMode: { type: String, default: '' },
    activeFilterCount: { type: Number, default: 0 },
    styleTypeOptions: { type: Array, default: () => [] },
    panelTotalCount: { type: Number, default: 0 },
    showPanelSummary: { type: Boolean, default: false },
  },
  data() {
    return {
      displayModeOptions: DISPLAY_MODE_OPTIONS,
    }
  },
}
</script>

<style scoped>
@import '../../resourceManage/genericResourceManage/linkListTheme.css';
@import '../../resourceManage/genericResourceManage/linkActionButtons.css';

.linkListFilterPanel {
  padding: 0;
  background: transparent;
}

.filterPanelSummary {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  margin-top: 8px;
  padding-top: 8px;
  border-top: 1px solid var(--link-line, #eee9e2);
}

.filterPanelSummary__label {
  font-size: var(--link-text-sm);
  color: var(--link-ink-secondary);
}

.filterPanelSummary__count {
  font-size: var(--link-text-lg);
  font-weight: var(--link-font-semibold);
  color: var(--link-accent);
  font-variant-numeric: tabular-nums;
}

.filterGrid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px 10px;
}

.filterGrid--three {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.filterItem {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  align-items: center;
  column-gap: 8px;
}

.searchText {
  font-family: var(--link-font-family);
  font-size: var(--link-text-sm);
  font-weight: var(--link-font-medium);
  color: var(--link-ink-secondary);
  text-align: right;
  white-space: nowrap;
}

.filterControl {
  width: 100%;
  max-width: 100%;
}

.filterDeckHeader {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
}

.filterDeckHeader__leading {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  min-width: 0;
}

.actionBar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 8px;
  flex-shrink: 0;
}

@media (max-width: 1100px) {
  .filterGrid--three {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 900px) {
  .filterGrid--three {
    grid-template-columns: 1fr;
  }

  .filterDeckHeader {
    flex-direction: column;
    align-items: stretch;
  }

  .actionBar {
    justify-content: flex-start;
  }
}
</style>
